export const deliveresMapped = (arr = []) => {
    let mewArray = [];

    arr?.map((item) => {
        mewArray.push({ title: item.name, value: item.id });
    });

    return mewArray;
};